import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getAdjustBalanceLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";
import { formatAdjustAmount } from "../../../../utils/adjustBalance";

const AdjustBalanceHistory = (props) => {
  const [adjustBalanceHistory, setAdjustBalanceHistory] = useState([]);
  const { adjust_balance_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getAdjustBalanceLog(adjust_balance_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setAdjustBalanceHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Adjust Balance Log
        </Typography>
      </Box>

      {response && adjustBalanceHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ESN</TableCell>
                    <TableCell align="left">MDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Balance Type</TableCell>
                    <TableCell align="left">Amount</TableCell>
                    <TableCell align="left">Subscription ID</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {adjustBalanceHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      {adjustBalanceHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/pwg/adjust_balance/batch/${adjustBalanceHistory.data.batch_id}`}
                      >
                        {adjustBalanceHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={adjustBalanceHistory.data.status}
                        size="small"
                        color={getChipColor(adjustBalanceHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {adjustBalanceHistory.data.balance_type}
                    </TableCell>
                    <TableCell align="left">
                      {formatAdjustAmount(
                        adjustBalanceHistory.data.balance_type,
                        adjustBalanceHistory.data.amount
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {adjustBalanceHistory.data.subscription_id}
                    </TableCell>
                    <TableCell align="left">
                      {adjustBalanceHistory.data.last_updated &&
                        `${format(
                          new Date(adjustBalanceHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={adjustBalanceHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default AdjustBalanceHistory;
